var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main audit-log-page" },
    [
      _c("h3", { staticClass: "title" }, [_vm._v("Analytics Dashboard")]),
      _vm._v(" "),
      _c("div", { staticClass: "audit-log-page__toolbar" }, [
        _c(
          "div",
          { staticClass: "audit-log-page__filters" },
          [
            _c(
              "el-radio-group",
              {
                attrs: { size: "small" },
                model: {
                  value: _vm.days,
                  callback: function($$v) {
                    _vm.days = $$v
                  },
                  expression: "days"
                }
              },
              _vm._l(_vm.DAY_RANGES, function(r) {
                return _c(
                  "el-radio-button",
                  { key: r.value, attrs: { label: r.value } },
                  [_vm._v(_vm._s(r.label))]
                )
              }),
              1
            ),
            _vm._v(" "),
            _c("span", { staticClass: "audit-log-page__filter-divider" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "audit-log-page__filter-group" },
              [
                _c("label", { staticClass: "audit-log-page__filter-label" }, [
                  _vm._v("Region")
                ]),
                _vm._v(" "),
                _c(
                  "el-select",
                  {
                    staticClass: "audit-log-page__region-filter",
                    attrs: { size: "small" },
                    model: {
                      value: _vm.region,
                      callback: function($$v) {
                        _vm.region = $$v
                      },
                      expression: "region"
                    }
                  },
                  [
                    _c("el-option", {
                      attrs: { label: "All Regions", value: "All" }
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.REGION_OPTIONS, function(r) {
                      return _c("el-option", {
                        key: r,
                        attrs: { label: r, value: r }
                      })
                    })
                  ],
                  2
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "audit-log-page__filter-group" },
              [
                _c("label", { staticClass: "audit-log-page__filter-label" }, [
                  _vm._v("Consultant")
                ]),
                _vm._v(" "),
                _c(
                  "el-select",
                  {
                    staticClass: "audit-log-page__consultant-filter",
                    attrs: {
                      multiple: "",
                      filterable: "",
                      remote: "",
                      "reserve-keyword": "",
                      "collapse-tags": "",
                      placeholder: "Search consultant",
                      size: "small",
                      loading: _vm.consultantSearchLoading,
                      "remote-method": _vm.searchConsultants
                    },
                    model: {
                      value: _vm.consultants,
                      callback: function($$v) {
                        _vm.consultants = $$v
                      },
                      expression: "consultants"
                    }
                  },
                  _vm._l(_vm.consultantOptions, function(name) {
                    return _c("el-option", {
                      key: name,
                      attrs: { label: name, value: name }
                    })
                  }),
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _vm.consultants.length
          ? _c(
              "div",
              { staticClass: "audit-log-page__selected-consultants" },
              _vm._l(_vm.consultants, function(name) {
                return _c(
                  "el-tag",
                  {
                    key: name,
                    attrs: { size: "small", closable: "" },
                    on: {
                      close: function($event) {
                        return _vm.removeConsultant(name)
                      }
                    }
                  },
                  [_vm._v(_vm._s(name))]
                )
              }),
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.summary && _vm.summary.earliestRecord
          ? _c(
              "span",
              { staticClass: "audit-log-page__since" },
              [
                _vm._v(
                  "\n      Data recorded since " +
                    _vm._s(_vm.formatDate(_vm.summary.earliestRecord)) +
                    "\n      "
                ),
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      effect: "dark",
                      placement: "bottom",
                      content:
                        'Entries with an unspecified source or a "Walton Portal" source are excluded from these analytics.'
                    }
                  },
                  [_c("em", { staticClass: "el-icon-info" })]
                )
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.section,
            callback: function($$v) {
              _vm.section = $$v
            },
            expression: "section"
          }
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "Overview", name: "overview" } },
            [
              _c(
                "section",
                { staticClass: "kpi-row" },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 16, type: "flex" } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c("MetricTile", {
                            attrs: {
                              label: "Active users",
                              value: _vm.summary
                                ? _vm.formatCount(_vm.summary.distinctUsers)
                                : "—",
                              caption: "Last " + _vm.days + " days"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c("MetricTile", {
                            attrs: {
                              label: "Response time",
                              value:
                                _vm.formatMsOrDash(
                                  _vm.summary && _vm.summary.avgLatencyMs
                                ) +
                                " – " +
                                _vm.formatMsOrDash(
                                  _vm.summary && _vm.summary.p95LatencyMs
                                ),
                              caption: "Avg - P95 · Web requests"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "MetricTile",
                            {
                              attrs: {
                                caption: "Last " + _vm.days + " days",
                                value: _vm.chartsLoading
                                  ? "—"
                                  : _vm.formatCount(
                                      _vm.summary && _vm.summary.loginAttempts
                                    )
                              }
                            },
                            [
                              _c(
                                "template",
                                { slot: "label" },
                                [
                                  _vm._v(
                                    "\n                Login attempts\n                "
                                  ),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        effect: "dark",
                                        placement: "top"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "content" },
                                          slot: "content"
                                        },
                                        [
                                          _vm._v(
                                            "\n                    Counts requests to the Azure AD B2C login page redirect, fired each time a user reaches"
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "\n                    the login screen - summed across web, Android, and iOS.\n                  "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("em", { staticClass: "el-icon-info" })
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "MetricTile",
                            {
                              attrs: {
                                caption: "Last " + _vm.days + " days",
                                value: _vm.chartsLoading
                                  ? "—"
                                  : _vm.formatCount(
                                      _vm.summary &&
                                        _vm.summary.successfulLogins
                                    )
                              }
                            },
                            [
                              _c(
                                "template",
                                { slot: "label" },
                                [
                                  _vm._v(
                                    "\n                Successful logins\n                "
                                  ),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        effect: "dark",
                                        placement: "top"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "content" },
                                          slot: "content"
                                        },
                                        [
                                          _vm._v(
                                            "\n                    Counts requests to the Azure AD B2C redirect fired after a login completes"
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "\n                    successfully - summed across web, Android, and iOS.\n                  "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("em", { staticClass: "el-icon-info" })
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c("MetricTile", {
                            attrs: {
                              label: "Most used platform",
                              value: _vm.chartsLoading
                                ? "—"
                                : _vm.topPlatform.label,
                              caption: _vm.topPlatform.caption
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c("MetricTile", {
                            attrs: {
                              label: "Busiest day",
                              value: _vm.chartsLoading ? "—" : _vm.topDay.label,
                              caption: _vm.topDay.caption
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                {
                  staticClass: "chart-row",
                  attrs: { gutter: 16, type: "flex" }
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "ChartCard",
                        {
                          attrs: {
                            title: "Requests by source",
                            subtitle:
                              "Website vs. mobile app usage · " +
                              _vm.formatCount(_vm.bySourceTotal) +
                              " total",
                            tooltip: _vm.CHART_TOOLTIPS.bySource
                          }
                        },
                        [
                          !_vm.chartsLoading
                            ? _c("PieChart", { attrs: { data: _vm.bySource } })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "ChartCard",
                        {
                          attrs: {
                            title: "Peak usage",
                            subtitle:
                              "Requests by hour of day and day of week, last " +
                              _vm.days +
                              " days",
                            tooltip: _vm.CHART_TOOLTIPS.peakUsage
                          }
                        },
                        [
                          !_vm.chartsLoading
                            ? _c("HeatmapChart", {
                                attrs: { data: _vm.hourlyHeatmap }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                {
                  staticClass: "chart-row",
                  attrs: { gutter: 16, type: "flex" }
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "ChartCard",
                        {
                          attrs: {
                            title: "Request volume",
                            subtitle:
                              "Audit log entries per day, last " +
                              _vm.days +
                              " days",
                            tooltip: _vm.CHART_TOOLTIPS.requestVolume
                          }
                        },
                        [
                          !_vm.chartsLoading
                            ? _c("DailyTrendChart", {
                                attrs: {
                                  data: _vm.dailyVolume,
                                  "date-key": "date",
                                  "value-key": "count",
                                  name: "Requests",
                                  color: "#5b8ff9",
                                  "value-formatter": _vm.formatCompactNumber,
                                  "date-formatter": _vm.formatAxisDate
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "ChartCard",
                        {
                          attrs: {
                            title: "Average response time",
                            subtitle: "Web requests only, per day",
                            tooltip: _vm.CHART_TOOLTIPS.responseTime
                          }
                        },
                        [
                          !_vm.chartsLoading
                            ? _c("DailyTrendChart", {
                                attrs: {
                                  data: _vm.dailyLatency,
                                  "date-key": "date",
                                  "value-key": "avgLatencyMs",
                                  name: "Avg latency",
                                  color: "#5ad8a6",
                                  "value-formatter": _vm.formatMs,
                                  "date-formatter": _vm.formatAxisDate
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "ChartCard",
                {
                  attrs: {
                    title: "Slow requests",
                    subtitle: "% of web requests over 2s, per day",
                    tooltip: _vm.CHART_TOOLTIPS.slowRequests,
                    wide: ""
                  }
                },
                [
                  !_vm.chartsLoading
                    ? _c("DailyTrendChart", {
                        attrs: {
                          data: _vm.slowRate,
                          "date-key": "date",
                          "value-key": "slowRate",
                          name: "Over 2s",
                          color: "#f2637b",
                          "value-formatter": _vm.formatPercent,
                          "date-formatter": _vm.formatAxisDate
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "Pages", name: "pages" } },
            [
              _c(
                "el-row",
                {
                  staticClass: "chart-row",
                  attrs: { gutter: 16, type: "flex" }
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "chart-card",
                          attrs: { shadow: "never" }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "chart-card__header" },
                            [
                              _c("div", [
                                _c(
                                  "h4",
                                  { staticClass: "chart-card__title" },
                                  [
                                    _vm._v(
                                      "\n                  Page visits\n                  "
                                    ),
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          placement: "top"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content"
                                          },
                                          [
                                            _vm._v(
                                              "\n                      A visit counts a user hitting any endpoint for a page once per day - not summed"
                                            ),
                                            _c("br"),
                                            _vm._v(
                                              "\n                      per endpoint call."
                                            ),
                                            _c("br"),
                                            _c("br"),
                                            _vm._v(
                                              "\n                      Includes: AOS, WEB, iOS. CMS admin activity is excluded.\n                    "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("em", {
                                          staticClass: "el-icon-info"
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  { staticClass: "chart-card__subtitle" },
                                  [
                                    _vm._v(
                                      "Visits and distinct visitors per page, last " +
                                        _vm._s(_vm.days) +
                                        " days"
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-radio-group",
                                {
                                  attrs: { size: "mini" },
                                  model: {
                                    value: _vm.pageVisitsView,
                                    callback: function($$v) {
                                      _vm.pageVisitsView = $$v
                                    },
                                    expression: "pageVisitsView"
                                  }
                                },
                                [
                                  _c(
                                    "el-radio-button",
                                    { attrs: { label: "list" } },
                                    [_vm._v("List")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-radio-button",
                                    { attrs: { label: "table" } },
                                    [_vm._v("Table")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "chart-card__body" },
                            [
                              _vm.pageVisitsView === "list"
                                ? _c("NamedCountList", {
                                    attrs: { rows: _vm.pageVisitsRows }
                                  })
                                : _c(
                                    "el-table",
                                    {
                                      directives: [
                                        {
                                          name: "loading",
                                          rawName: "v-loading",
                                          value: _vm.chartsLoading,
                                          expression: "chartsLoading"
                                        }
                                      ],
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        data: _vm.pageEngagement,
                                        size: "small"
                                      }
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "Page",
                                          prop: "name",
                                          "show-overflow-tooltip": ""
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: { label: "Total visits" },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function(scope) {
                                              return [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formatCount(
                                                      scope.row.totalVisits
                                                    )
                                                  )
                                                )
                                              ]
                                            }
                                          }
                                        ])
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: { label: "Distinct visitors" },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function(scope) {
                                              return [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formatCount(
                                                      scope.row.distinctVisitors
                                                    )
                                                  )
                                                )
                                              ]
                                            }
                                          }
                                        ])
                                      })
                                    ],
                                    1
                                  )
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "ChartCard",
                {
                  attrs: {
                    title: "Page trend",
                    subtitle:
                      "Visits per day for the top " +
                      _vm.pageDailyTrend.length +
                      " pages, last " +
                      _vm.days +
                      " days",
                    tooltip: _vm.CHART_TOOLTIPS.pageTrend,
                    wide: ""
                  }
                },
                [
                  !_vm.chartsLoading
                    ? _c("PageTrendChart", {
                        attrs: {
                          data: _vm.pageDailyTrend,
                          "value-formatter": _vm.formatCompactNumber,
                          "date-formatter": _vm.formatAxisDate
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e3d187e2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3d187e2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auditLog/AuditLog.vue
// module id = null
// module chunks = 